import { createFrontendModule } from '@backstage/frontend-plugin-api';

import { migrationApi } from './api';
import {
  componentMigrationContent,
  gitHubMigrationPage,
  groupMigrationContent,
} from './extensions';

/**
 * The migration API and the standalone admin page belong to the `app` plugin;
 * the two entity tabs must be contributed to `catalog`, since that is the
 * plugin whose entity pages they extend.
 */
export const migrationModule = createFrontendModule({
  pluginId: 'app',
  extensions: [migrationApi, gitHubMigrationPage],
});

export const migrationCatalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [groupMigrationContent, componentMigrationContent],
});

export { useIsDevopsAdmin } from './common';
